import React from "react";
import { Outlet, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import ChangePasswordCard from "@/components/ChangePasswordCard";
import ChangeEmailCard from "@/components/ChangeEmailCard";
import { LogOut, Droplets, KeyRound, ShoppingCart } from "lucide-react";

export default function CustomerLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-30 backdrop-blur-xl bg-background/80 border-b border-border no-print">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-2">
          <Link to="/portal" className="flex items-baseline gap-1 shrink-0">
            <Droplets className="w-5 h-5 mr-1 text-primary" />
            <span className="text-base sm:text-xl font-black tracking-tighter text-primary font-display">CATSKILLS</span>
            <span className="text-[10px] sm:text-sm font-light tracking-wide">POOL</span>
          </Link>
          <div className="flex items-center gap-2 sm:gap-3">
            <Link to="/portal/shop">
              <Button variant="outline" size="sm" className="rounded-sm" data-testid="portal-nav-shop" title="Shop products">
                <ShoppingCart className="w-4 h-4 sm:mr-2" /> <span className="hidden sm:inline">Shop</span>
              </Button>
            </Link>
            <span className="text-sm text-muted-foreground hidden md:inline truncate max-w-[200px]">{user?.email}</span>
            <Dialog>
              <DialogTrigger asChild>
                <Button variant="outline" size="sm" className="rounded-sm" data-testid="portal-account-button" title="Change password">
                  <KeyRound className="w-4 h-4" />
                </Button>
              </DialogTrigger>
              <DialogContent className="max-w-md rounded-sm">
                <DialogHeader>
                  <DialogTitle className="font-display">My account</DialogTitle>
                  <DialogDescription>Signed in as {user?.email}</DialogDescription>
                </DialogHeader>
                <div className="space-y-4">
                  <ChangeEmailCard compact testId="portal-change-email" />
                  <ChangePasswordCard compact testId="portal-change-password" />
                </div>
              </DialogContent>
            </Dialog>
            <Button variant="outline" size="sm" className="rounded-sm" onClick={async () => { await logout(); navigate("/login"); }}
                    data-testid="portal-logout-button">
              <LogOut className="w-4 h-4 sm:mr-2" /> <span className="hidden sm:inline">Sign out</span>
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-6 sm:py-10 lg:py-16">
        <Outlet />
      </main>
    </div>
  );
}
